import { FC } from 'react';
import CollapsableMessage from '../collapsable-message/collapsable-message';
import CollapsableMessagesSkeleton from '../collapsable-messages-skeleton/collapsable-messages-skeleton';
import { CollapsableSize, CollapsableEditModeI, Comment } from '../types/ui-kit.types';

export interface CollapsableMessagesPanelI {
    size: CollapsableSize;
    comments: Comment[];
    isLoadingMessages: boolean;
    isLoadingActions: boolean;
    editMode: CollapsableEditModeI;
    emptyMessage: string;
    onEdit?(id: string, message: string): void;
    onDelete?(id: string): void;
}

const CollapsableMessagesPanel: FC<CollapsableMessagesPanelI> = ({
    size,
    comments,
    isLoadingMessages,
    isLoadingActions,
    editMode,
    emptyMessage = 'Aún no hay comentarios.',
    onEdit,
    onDelete,
}) => {
    return (
        <div className="bg-surface-light border-y border-gray-50 p-2 max-h-48 overflow-y-auto">
            {isLoadingMessages ? (
                <CollapsableMessagesSkeleton />
            ) : comments?.length ? (
                <div className="flex flex-col space-y-2">
                    {comments?.map((comment: Comment) => (
                        <CollapsableMessage
                            id={comment.id}
                            name={comment.name}
                            date={comment.date}
                            message={comment.comment}
                            size={size}
                            isEditing={editMode.isEditing}
                            editDisabled={isLoadingActions}
                            deleteDisabled={isLoadingActions && comment.id === editMode.editedCommentId}
                            onEdit={onEdit}
                            onDelete={onDelete}
                        />
                    ))}
                </div>
            ) : (
                <div className="flex items-center justify-center p-1">
                    <span className="text-sm text-surface-disabled">{emptyMessage}</span>
                </div>
            )}
        </div>
    );
};

export default CollapsableMessagesPanel;
